/**
 * Che cosa apre `mme.mative.ai`: il sito pubblico o il portale (decisione 0008).
 *
 * Chi arriva senza una sessione vede il sito; chi l'ha gia', o sta tornando dal login, il
 * portale. La regola sta qui, pura e provata da `ingresso.test.ts`, perche' sbagliarla costa
 * caro in due modi opposti: un visitatore mandato al portale finisce sulla pagina di login di
 * Keycloak, e un utente mandato al sito di ritorno dal login perde la sessione appena nata.
 */

import { sectionOf } from '@/config/navigation';

/** Le pagine del sito che si aprono sempre, con o senza sessione. */
export const PAGINE_DEL_SITO = ['/privacy', '/termini', '/cookies'] as const;

/** Il link «Accedi»: apre il portale, che senza sessione porta al login. */
export const ACCEDI = '/accedi';

/**
 * `oidc-client-ts` salva l'utente in `sessionStorage` con questa chiave
 * (`oidc.user:<issuer>:<client>`, `auth/authConfig.ts`). Basta sapere che c'e': il portale
 * controlla poi da se' se il token e' ancora buono.
 */
const SESSIONE = /^oidc\.user:/;

export type Ingresso = 'sito' | 'portale';

export function ingresso(percorso: string, query: string, chiaviSessione: readonly string[]): Ingresso {
  const pagina = percorso.replace(/\/+$/, '') || '/';
  if ((PAGINE_DEL_SITO as readonly string[]).includes(pagina)) return 'sito';
  if (pagina === ACCEDI) return 'portale';
  // L'indirizzo di una sezione (`/settings`, D69) e' del portale anche senza sessione: una scheda
  // nuova non ha quella della scheda di prima, e il login la riporta li'.
  if (sectionOf(pagina)) return 'portale';
  // Il ritorno da Keycloak, riuscito o no: `code` o `error`, sempre con `state`.
  const parametri = new URLSearchParams(query);
  if (parametri.has('state') && (parametri.has('code') || parametri.has('error'))) return 'portale';
  if (chiaviSessione.some((chiave) => SESSIONE.test(chiave))) return 'portale';
  return 'sito';
}
